import classnames from 'classnames';
import BackDropPopover from '../BackDropPopover/BackDropPopover';
import IconButton from '../IconButton/IconButton';
import PopSlider from '../PopSlider/PopSlider';
import ShaderPopover from '../ShaderPopOver/ShaderPopOver';
import { defaultValues } from './Holodeck.data';
import { Wrapper } from './Holodeck.style';

type PopId = 'background' | 'grid' | 'ambience' | 'backdrop';
type ParamType = 'color' | 'intensity' | 'enabled';

export type HolodeckProps = {
  holodeckState: IHolodeckState;
  backdrops: IShader[];
  shaders: IShader[];
  onChange: (popId: PopId, paramType: ParamType, value: string | number | boolean) => void;
  onSet: (popId: PopId, paramType: ParamType, value: string | number | boolean) => void;
  onReset: () => void;
};

export function Holodeck(props: HolodeckProps) {
  const { backdrops, shaders, holodeckState } = props;
  const {
    gridLinesColor,
    gridLinesOpacity,
    lightColor,
    lightIntensity,
    backgroundColor,
    backgroundIntensity,
  } = holodeckState;

  const onChange = (popId: PopId) => (paramType: ParamType, value: string | number | boolean) => {
    props.onChange(popId, paramType, value);
  };

  const onSet = (popId: PopId) => (paramType: ParamType, value: string | number | boolean) => {
    props.onSet(popId, paramType, value);
  };

  const className = classnames('Holodeck-wrapper', {});

  return (
    <Wrapper className={className} data-testid='Holodeck-wrapper'>
      <IconButton size={20} name='IconRotate' color='#ffffff99' onClick={props.onReset} />

      <BackDropPopover backdrops={backdrops} holodeck={holodeckState} onSet={onSet('backdrop')} />
      <ShaderPopover shaders={shaders} holodeck={holodeckState} onSet={onSet('shader')} />

      <PopSlider
        header='Canvas Background'
        value={backgroundIntensity}
        colorValue={backgroundColor}
        iconName='IconPalette'
        onChange={onChange('background')}
        onSet={onSet('background')}
        defaultValues={defaultValues['background']}
      />
      <PopSlider
        header='Grid Lines'
        value={gridLinesOpacity}
        colorValue={gridLinesColor}
        iconName='IconGrid4x4'
        onChange={onChange('grid')}
        onSet={onSet('grid')}
        defaultValues={defaultValues['grid']}
      />
      <PopSlider
        header='Ambient Light'
        value={lightIntensity}
        colorValue={lightColor}
        iconName='IconSun'
        onChange={onChange('ambience')}
        onSet={onSet('ambience')}
        defaultValues={defaultValues['ambience']}
        max={6}
      />
    </Wrapper>
  );
}

export default Holodeck;
